module.exports = __webpack_public_path__ + "static/media/mem5YaGs126MiZpBA-UNirkOXOhpOqc.f5f8ba17.woff2";